<template>
  <div class="hello">
    <input v-model="user_input_code" v-on:input="decoder" class="input_code" v-bind:value="user_input_code"
           placeholder="код для расшифровки">
    <h2 v-if="code_decode_str[1] != None">{{ msg }}: {{ user_input_code }}</h2>
    <!-- Страна -->
    <p v-for="country in countrys" v-if="code_decode_str[0] == country.value">Страна: {{ country.name }}</p>
    <!-- Номер конвейера -->
    <p v-if="code_decode_str[1] != None">Номер конвейера: {{code_decode_str[1]}}</p>
    <p v-for="feature in features" v-if="code_decode_str[2] == feature.value">{{ feature.text }}</p>
    <p v-if="code_decode_str[3] != None">Год: {{code_decode_str[3]}}</p>
    <p v-for="date in code" v-if="code_decode_str[3] + code_decode_str[4] + code_decode_str[5] == date.value">Дата: {{ date.text }}</p>
    <p v-if="code_decode_str[6] != None & code_decode_str[7] != None">День: {{code_decode_str[6]+code_decode_str[7]}}</p>
    <p v-if="code_decode_str[8] != None">Смена: {{code_decode_str[8]}}</p>

  </div>
</template>



<script>
  export default {
    name: 'InputCode',
    methods: {
      decoder: function (event) {
//        alert('Привет ' + event.target.value + '!')
//        this.code_decode_str = event.target.value
        var code = event.target.value
//        this.code_decode_str = code
//        alert(code)
        var ArrCode = Array.from(code.toUpperCase())
        this.code_decode_str = ArrCode
      }
    },
    data () {
      return {
        msg: 'Расшифровка',
        user_input_code: '',
        code_decode_str: '',
        countrys: [
          {name: 'Германия (Ганновер)', value: 'H'},
          {name: 'Чехия (Чешска Липа)', value: 'C'},
          {name: 'Швеция (Хальтсфред)', value: 'S'},
          {name: 'Австрия (Вена)', value: 'A'},
          {name: 'Франция (Руан)', value: 'F'},
          {name: 'Франция (Руан)', value: 'R'},
          {name: 'Испания (Гвардамар - Бургос)', value: 'E'},
          {name: 'Испания (Гвардамар - Бургос)', value: 'G'}
        ],
        features: [
          {text: 'Для розничной продажи', value: 'V'},
          {text: 'Для комплектации на автозаводах', value: 'E'},
          {text: 'Изготовлен по заказу партнера', value: 'C'}
        ],
        code: [
          {text: 'Январь 2014', value: '417'},
          {text: 'Январь 2015', value: '517'},
          {text: 'Январь 2016', value: '617'},
          {text: 'Январь 2017', value: '717'},
          {text: 'Январь 2018', value: '817'},
          {text: 'Январь 2019', value: '917'},
          {text: 'Январь 2020', value: '037'},
          {text: 'Январь 2021', value: '137'},
          {text: 'Январь 2022', value: '237'},
          {text: 'Январь 2023', value: '337'},
          {text: 'Январь 2024', value: '437'},
          {text: 'Январь 2025', value: '537'},
          {text: 'Январь 2026', value: '637'},
          {text: 'Январь 2027', value: '737'},
          {text: 'Январь 2028', value: '837'},
          {text: 'Январь 2029', value: '937'},
          {text: 'Февраль 2014', value: '418'},
          {text: 'Февраль 2015', value: '518'},
          {text: 'Февраль 2016', value: '618'},
          {text: 'Февраль 2017', value: '718'},
          {text: 'Февраль 2018', value: '818'},
          {text: 'Февраль 2019', value: '918'},
          {text: 'Февраль 2020', value: '038'},
          {text: 'Февраль 2021', value: '138'},
          {text: 'Февраль 2022', value: '238'},
          {text: 'Февраль 2023', value: '338'},
          {text: 'Февраль 2024', value: '438'},
          {text: 'Февраль 2025', value: '538'},
          {text: 'Февраль 2026', value: '638'},
          {text: 'Февраль 2027', value: '738'},
          {text: 'Февраль 2028', value: '838'},
          {text: 'Февраль 2029', value: '938'},
          {text: 'Март 2014', value: '419'},
          {text: 'Март 2015', value: '519'},
          {text: 'Март 2016', value: '619'},
          {text: 'Март 2017', value: '719'},
          {text: 'Март 2018', value: '819'},
          {text: 'Март 2019', value: '919'},
          {text: 'Март 2020', value: '039'},
          {text: 'Март 2021', value: '139'},
          {text: 'Март 2022', value: '239'},
          {text: 'Март 2023', value: '339'},
          {text: 'Март 2024', value: '439'},
          {text: 'Март 2025', value: '539'},
          {text: 'Март 2026', value: '639'},
          {text: 'Март 2027', value: '739'},
          {text: 'Март 2028', value: '839'},
          {text: 'Март 2029', value: '939'},
          {text: 'Апрель 2014', value: '420'},
          {text: 'Апрель 2015', value: '520'},
          {text: 'Апрель 2016', value: '620'},
          {text: 'Апрель 2017', value: '720'},
          {text: 'Апрель 2018', value: '820'},
          {text: 'Апрель 2019', value: '920'},
          {text: 'Апрель 2020', value: '040'},
          {text: 'Апрель 2021', value: '140'},
          {text: 'Апрель 2022', value: '240'},
          {text: 'Апрель 2023', value: '340'},
          {text: 'Апрель 2024', value: '440'},
          {text: 'Апрель 2025', value: '540'},
          {text: 'Апрель 2026', value: '640'},
          {text: 'Апрель 2027', value: '740'},
          {text: 'Апрель 2028', value: '840'},
          {text: 'Апрель 2029', value: '940'},
          {text: 'Май 2014', value: '453'},
          {text: 'Май 2015', value: '553'},
          {text: 'Май 2016', value: '653'},
          {text: 'Май 2017', value: '753'},
          {text: 'Май 2018', value: '853'},
          {text: 'Май 2019', value: '953'},
          {text: 'Май 2020', value: '073'},
          {text: 'Май 2021', value: '173'},
          {text: 'Май 2022', value: '273'},
          {text: 'Май 2023', value: '373'},
          {text: 'Май 2024', value: '473'},
          {text: 'Май 2025', value: '573'},
          {text: 'Май 2026', value: '673'},
          {text: 'Май 2027', value: '773'},
          {text: 'Май 2028', value: '873'},
          {text: 'Май 2029', value: '973'},
          {text: 'Июнь 2014', value: '454'},
          {text: 'Июнь 2015', value: '554'},
          {text: 'Июнь 2016', value: '654'},
          {text: 'Июнь 2017', value: '754'},
          {text: 'Июнь 2018', value: '854'},
          {text: 'Июнь 2019', value: '954'},
          {text: 'Июнь 2020', value: '074'},
          {text: 'Июнь 2021', value: '174'},
          {text: 'Июнь 2022', value: '274'},
          {text: 'Июнь 2023', value: '374'},
          {text: 'Июнь 2024', value: '474'},
          {text: 'Июнь 2025', value: '574'},
          {text: 'Июнь 2026', value: '674'},
          {text: 'Июнь 2027', value: '774'},
          {text: 'Июнь 2028', value: '874'},
          {text: 'Июнь 2029', value: '974'},
          {text: 'Июль 2014', value: '455'},
          {text: 'Июль 2015', value: '555'},
          {text: 'Июль 2016', value: '655'},
          {text: 'Июль 2017', value: '755'},
          {text: 'Июль 2018', value: '855'},
          {text: 'Июль 2019', value: '955'},
          {text: 'Июль 2020', value: '075'},
          {text: 'Июль 2021', value: '175'},
          {text: 'Июль 2022', value: '275'},
          {text: 'Июль 2023', value: '375'},
          {text: 'Июль 2024', value: '475'},
          {text: 'Июль 2025', value: '575'},
          {text: 'Июль 2026', value: '675'},
          {text: 'Июль 2027', value: '775'},
          {text: 'Июль 2028', value: '875'},
          {text: 'Июль 2029', value: '975'},
          {text: 'Август 2014', value: '456'},
          {text: 'Август 2015', value: '556'},
          {text: 'Август 2016', value: '656'},
          {text: 'Август 2017', value: '756'},
          {text: 'Август 2018', value: '856'},
          {text: 'Август 2019', value: '956'},
          {text: 'Август 2020', value: '076'},
          {text: 'Август 2021', value: '176'},
          {text: 'Август 2022', value: '276'},
          {text: 'Август 2023', value: '376'},
          {text: 'Август 2024', value: '476'},
          {text: 'Август 2025', value: '576'},
          {text: 'Август 2026', value: '676'},
          {text: 'Август 2027', value: '776'},
          {text: 'Август 2028', value: '876'},
          {text: 'Август 2029', value: '976'},
          {text: 'Сентябрь 2014', value: '457'},
          {text: 'Сентябрь 2015', value: '557'},
          {text: 'Сентябрь 2016', value: '657'},
          {text: 'Сентябрь 2017', value: '757'},
          {text: 'Сентябрь 2018', value: '857'},
          {text: 'Сентябрь 2019', value: '957'},
          {text: 'Сентябрь 2020', value: '077'},
          {text: 'Сентябрь 2021', value: '177'},
          {text: 'Сентябрь 2022', value: '277'},
          {text: 'Сентябрь 2023', value: '377'},
          {text: 'Сентябрь 2024', value: '477'},
          {text: 'Сентябрь 2025', value: '577'},
          {text: 'Сентябрь 2026', value: '677'},
          {text: 'Сентябрь 2027', value: '777'},
          {text: 'Сентябрь 2028', value: '877'},
          {text: 'Сентябрь 2029', value: '977'},
          {text: 'Октябрь 2014', value: '458'},
          {text: 'Октябрь 2015', value: '558'},
          {text: 'Октябрь 2016', value: '658'},
          {text: 'Октябрь 2017', value: '758'},
          {text: 'Октябрь 2018', value: '858'},
          {text: 'Октябрь 2019', value: '958'},
          {text: 'Октябрь 2020', value: '078'},
          {text: 'Октябрь 2021', value: '178'},
          {text: 'Октябрь 2022', value: '278'},
          {text: 'Октябрь 2023', value: '378'},
          {text: 'Октябрь 2024', value: '478'},
          {text: 'Октябрь 2025', value: '578'},
          {text: 'Октябрь 2026', value: '678'},
          {text: 'Октябрь 2027', value: '778'},
          {text: 'Октябрь 2028', value: '878'},
          {text: 'Октябрь 2029', value: '978'},
          {text: 'Ноябрь 2014', value: '459'},
          {text: 'Ноябрь 2015', value: '559'},
          {text: 'Ноябрь 2016', value: '659'},
          {text: 'Ноябрь 2017', value: '759'},
          {text: 'Ноябрь 2018', value: '859'},
          {text: 'Ноябрь 2019', value: '959'},
          {text: 'Ноябрь 2020', value: '079'},
          {text: 'Ноябрь 2021', value: '179'},
          {text: 'Ноябрь 2022', value: '279'},
          {text: 'Ноябрь 2023', value: '379'},
          {text: 'Ноябрь 2024', value: '479'},
          {text: 'Ноябрь 2025', value: '579'},
          {text: 'Ноябрь 2026', value: '679'},
          {text: 'Ноябрь 2027', value: '779'},
          {text: 'Ноябрь 2028', value: '879'},
          {text: 'Ноябрь 2029', value: '979'},
          {text: 'Декабрь 2014', value: '460'},
          {text: 'Декабрь 2015', value: '560'},
          {text: 'Декабрь 2016', value: '660'},
          {text: 'Декабрь 2017', value: '760'},
          {text: 'Декабрь 2018', value: '860'},
          {text: 'Декабрь 2019', value: '960'},
          {text: 'Декабрь 2020', value: '080'},
          {text: 'Декабрь 2021', value: '180'},
          {text: 'Декабрь 2022', value: '280'},
          {text: 'Декабрь 2023', value: '380'},
          {text: 'Декабрь 2024', value: '480'},
          {text: 'Декабрь 2025', value: '580'},
          {text: 'Декабрь 2026', value: '680'},
          {text: 'Декабрь 2027', value: '780'},
          {text: 'Декабрь 2028', value: '880'},
          {text: 'Декабрь 2029', value: '980'}
        ]
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .input_code {
    width: 250px;
  }
</style>



// WEBPACK FOOTER //
// src/components/InputCode.vue